import { render, staticRenderFns } from "./BnLoadingWindow.vue?vue&type=template&id=03a57da9&scoped=true&"
import script from "./BnLoadingWindow.vue?vue&type=script&lang=js&"
export * from "./BnLoadingWindow.vue?vue&type=script&lang=js&"
import style0 from "./BnLoadingWindow.vue?vue&type=style&index=0&id=03a57da9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a57da9",
  null
  
)

export default component.exports